import Index from './views/rules/Index.vue'
import Definitions from './views/rules/Definitions.vue'
import Settings from './views/rules/Settings.vue'
import Specifications from './views/rules/Specifications.vue'

const moduleRoute = {
  path: '/repasse_medico',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('./views/Home.vue'),
      children: [
        {
          path: 'relatorio_de_repasse',
          component: () => import('./views/Report.vue')
        },
        {
          path: 'producao',
          component: () => import('./views/ProductionReport.vue')
        },
        { path: 'extratos', component: () => import('./views/Extracts.vue') },
        { path: 'perfis', component: () => import('./views/Profiles.vue') },
        {
          path: 'regras_de_repasse',
          component: () => import('./views/Rules.vue')
        },
        {
          path: 'configuracoes',
          component: () => import('./views/Configuration.vue')
        },
        {
          path: 'regra_repasse/:id/:tab',
          component: () => import('./views/rules/Index.vue')
        }
      ]
    }
  ]
}

// "Minha Produção" (perfil médico): produção travada no próprio profissional,
// fora das abas do repasse — o médico não vê o restante do módulo.
// Path com HÍFEN, como o resto do menu Funcionalidades
// (/configuracoes-da-clinica, /relatorios-gerenciais, /visao-geral) — só as
// rotas antigas do repasse usam underscore. O alias com underscore fica porque
// foi o path da primeira versão: sem ele, quem digitar/guardar a URL antiga cai
// numa tela 100% branca (o router não tem rota de fallback para path sem match).
const moduleRouteMyProduction = {
  path: '/minha-producao',
  alias: '/minha_producao',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('./views/MyProduction.vue')
    }
  ]
}

const moduleRouteRules = {
  path: '/regras_repasse',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: Index,
      children: [
        { path: ':id/definicoes', component: Definitions },
        { path: ':id/configuracoes', component: Settings },
        { path: ':id/especificacoes', component: Specifications }
      ]
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
  router.addRoute(moduleRouteMyProduction)
  router.addRoute(moduleRouteRules)
}
